<template>
  <InlineMessage :severity="severity">{{ message }}</InlineMessage>
</template>

<script>
// import InlineMessage from "primevue/inlinemessage/sfc";

import { defineAsyncComponent } from 'vue'
const InlineMessage = defineAsyncComponent(() =>
  import('primevue/inlinemessage')
)

export default {
  setup() {},
  components: {
    InlineMessage,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    severity: {
      /* severity : info,success,warn,error */
      type: String,
      default: "info",
    },
  },
};
</script>

<style lang="scss" scoped>
</style>